export default {
  SN_PRIORITY_OPTIONS: [
    { label: '1 - High / 1 - High / 1 - Critical', value: '1|1|1' },
    { label: '1 - High / 2 - Medium /	2 - High', value: '1|2|2' },
    { label: '1 - High / 3 - Low / 3 - Moderate', value: '1|3|3' },
    { label: '2 - Medium / 1 - High / 2 - High', value: '2|1|2' },
    { label: '2 - Medium / 2 - Medium / 3 - Moderate', value: '2|2|3' },
    { label: '2 - Medium / 3 - Low / 4 - Low', value: '2|3|4' },
    { label: '3 - Low / 1 - High / 3 - Moderate', value: '3|1|3' },
    { label: '3 - Low / 2 - Medium / 4 - Low', value: '3|2|4' },
    { label: '3 - Low / 3 - Low / 5 - Planning', value: '3|3|5' }
  ]
};
